import { render, staticRenderFns } from "./invoicechannel.vue?vue&type=template&id=2f0717f2&"
import script from "./invoicechannel.vue?vue&type=script&lang=js&"
export * from "./invoicechannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports